import { UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component ,Input} from '@angular/core';

@Component({
  selector: 'app-adminaudit-export',
  templateUrl: './adminaudit-export.component.html',
  styleUrls: ['./adminaudit-export.component.scss']
})
export class AdminauditExportComponent {
  @Input() public Content: any;
  MonoWindowPDF: UntypedFormGroup
  public content: any;
  log_data: any[] = [];
  details_data: any;
  category: string;
  src: string;
  Orgtimezone:any;
  orgCode: string;
  now = new Date();
  Datestring: any;
  constructor(public modalRef:NgbActiveModal , private userService: UserService, public datepipe: DatePipe,
    private commonService: UserService) {
    this.src = "../../../assets/images/logo1.png";
    this.orgCode = this.commonService.getOrgCode();

  }

  ngOnInit(): void {
    this.log_data = [];
    this.details_data = [];
    this.category = "";
    this.Orgtimezone = this.userService.getLoggedUserOrgTimeZone();
    if (this.Content.content.log_data != null && (this.Content.content.log_data.length == 1 || this.Content.content.log_data.length > 1)) {
      this.log_data = this.Content.content.log_data;
    }
    else {
      this.log_data.push(this.Content.content.log_data);
    }
    this.details_data = this.Content.content.details_data;
    this.category = this.Content.content.cat_type;
    this.userService.getLogo(this.orgCode).subscribe(result => {
      if (result === null || result === undefined || result === '') {
        this.src = "../../../assets/images/logo1.png";
      }
      else {
        if (result.FileExt == 'svg') {
          this.src = 'data:image/svg+xml;base64,' + result.Image;
        }
        else {
          this.src = 'data:image/png;base64,' + result.Image;
        }
      }
    });
  }

  closePopup() {
    this.modalRef.dismiss();
  }
}
